import { createFileRoute, notFound } from "@tanstack/react-router";
import checkoutStyles from "../styles/shop-checkout.css?url";
import shopStyles from "../styles/shop.css?url";
import { CheckoutPage } from "../components/shop/checkout-page";
import { DemoPaymentPage } from "../components/membership/demo-payment-page";
import { keepSearch } from "../lib/search";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadOrderPage } from "../server/shop";

/**
 * Checkout (/merch/checkout?order=...). The page carries nothing about the order: the payment
 * script fetches it with the buyer's token. No referrer leaves it, even after a navigation in
 * place.
 */
export const Route = createFileRoute("/merch/checkout")({
  validateSearch: keepSearch,
  loader: async () => {
    const page = await loadOrderPage({ data: "checkout" });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = withStylesheet(
      withStylesheet(
        creatorPageHead(shell, {
          pathname: "/merch/checkout",
          title: `Checkout | ${loaderData.creatorName}`,
          description: shell.creator.description,
          noindex: true,
        }),
        shopStyles,
      ),
      checkoutStyles,
    );
    return { ...head, meta: [...(head.meta ?? []), { name: "referrer", content: "no-referrer" }] };
  },
  component: Checkout,
});

function Checkout() {
  const data = Route.useLoaderData();
  const search = Route.useSearch();
  if (typeof search.demo_session === "string") return <DemoPaymentPage kind="shop" />;
  return <CheckoutPage creatorId={data.creatorId} sample={data.sample} />;
}
